export default {
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000984'), //공장코드
				prop: 'plntCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000985'), //공장명
				prop: 'plntNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWCC000688'), //공정코드
				prop: 'powCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWCC000403'), //공정명
				prop: 'powNm',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000986'), //샵코드
				prop: 'shopCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWPP000177'), //라인코드
				prop: 'lnCd',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWPP000137'), //시퀀스
				prop: 'sort',
				minWidth: '150px'
			}
		];
	}
};
